import Loading from './Loading';
import Error from './Error';

export const error = new Error({});
export const loading = new Loading();

export default {error, loading};